@if (isLoading()) {
  <div class="global-loading-overlay">
    <mat-spinner color="primary" [diameter]="100" />
  </div>
}
